
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const ClaimSection = () => {
  return (
    <div className="py-12 bg-gradient-to-r from-primary/5 to-primary/10">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-center">
          Already Listed? Claim Your Business
        </h2>
        
        <Alert className="mb-6">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Take control of your business listing</AlertTitle>
          <AlertDescription>
            Claiming your business allows you to:
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>Update your business information</li>
              <li>Access new features and insights</li>
              <li>Build trust with potential customers</li>
            </ul>
          </AlertDescription>
        </Alert>

        <div className="bg-white p-6 rounded-lg shadow-sm border">
          <h3 className="text-xl font-semibold mb-4">How to Claim Your Business:</h3>
          <ol className="space-y-3 text-muted-foreground">
            <li className="flex gap-3">
              <span className="font-semibold text-primary">1.</span>
              <span>Visit your business's page on HomeProsOKC</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-primary">2.</span>
              <span>Click the "Claim This Business" button</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-primary">3.</span>
              <span>Fill out the verification form with your business details</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-primary">4.</span>
              <span>Our team will verify your information within one week</span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};
